import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API, withCredentials: true });

http.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("ns_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});
